"use strict";

// Module API

function checkUnique() {
  return true;
}

module.exports = {
  checkUnique: checkUnique
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/unique.js
// module id = 330
// module chunks = 0